define('contactForm',['jquery'],
function ($) {
    var $formElement = $('#contact-form');

    if (!$formElement.length) {
        return;
    }

    var $submitButton = $('.contact-form__submit');
    var $inputs = $formElement.find('input:not([type=checkbox]), textarea');
    var $checkbox = $formElement.find('input[type=checkbox]');
    var apiUrl = '/api/contactform/SendEmail';
    var $errorMessage = $('.contact-form__error');
    var $successMessage = $('.contact-form__receipt');
    var $failedMessage = $('.contact-form__failed');
    var $formContent = $('.contact-form__content');

    $submitButton.on('click', function (e) {
        e.preventDefault();
        submitForm();
    });

    function showError() {
        $errorMessage.removeClass('hidden');

        var $errorElements = $('.error');

        $errorElements.first().focus();
        $errorElements.one('change', function () {
            $(this).removeClass('error');
        });
    }

    function submitForm() {
        var formData = '?';
        var requiredInputIsEmpty = false;
        $inputs.each(function() {
            var $this = $(this);
            if ($this.val()) {
                formData += $this.attr('name') + '=' + encodeURI($this.val()) + '&';
            } else if ($this.attr('required')) {
                requiredInputIsEmpty = true;
                $this.addClass('error');
            }
        });

        if (!$checkbox[0].checked) {
            $checkbox.addClass('error');
            requiredInputIsEmpty = true;
        }

        if (requiredInputIsEmpty) {
            showError();
            return;
        } else {
            formData += 'pageName=' + encodeURI(document.title);
        }

        $errorMessage.addClass('hidden');
        $submitButton.addClass('loading');
        $formElement.addClass('loading');

        $.get(apiUrl + formData, function (response) {
            $submitButton.removeClass('loading');

            if (response === "success") {
                $errorMessage.addClass('hidden');
                $failedMessage.addClass('hidden');
                $successMessage.removeClass('hidden');
                $formContent.slideUp();
            } else {
                $failedMessage.removeClass('hidden');
                $formElement.removeClass('loading');
            }
        });
    }
});

